<section class="my-account">
  <h1 class="reservation-details">
    MY ACCOUNT
  </h1>
  <section class="row acc-numb acc-height">
    <section class="col-xs-8 col-sm-8 col-md-8 acc-title">
      @if (baseSiteId) {
        <img [src]="'/icons/'+baseSiteId+'/user-account.svg'" alt="Account">
      }
      <span class="acc-pos">Account&nbsp;{{accntId}}</span>
    </section>
    <section class="col-xs-4 col-sm-4 col-md-4 acc-title-manage">
      <a (click)="navigateToAccountTab()">
        @if (baseSiteId) {
          <img [src]="'/icons/'+baseSiteId+'/edit.svg'" alt="Edit">
        }
      Manage </a>
    </section>
  </section>
  <hr>
  </section>
  <section class="section-one">
    <section id="filter-by">
      <ul>
        <li class="myacc_representatives">
          @if (customerRepDetails != undefined && customerRepDetails.length > 0) {
            <div class="">
              @for (acc of customerRepDetails; track acc; let in = $index) {
                <section class="sec-rep">
                  <div class="img-container">
                    @if (acc?.profilePic) {
                      <img [src]="getImage(acc)" alt="Sales Rep">
                    }
                    @if (!acc?.profilePic) {
<img [src]="path.includes('vsh') ? '/img/AccProfile.png' :
              path.includes('vax') ? '/img/favicon_vax.ico' :
              '/img/default.png'" alt="Representative Image">
                      }
                    </div>
                    <div class="txt-container">
                      @if (acc?.repName.length != 0) {
                        <h4 style="text-transform: capitalize">{{acc?.repName}}</h4>
                      }
                      @if (acc?.repDescription.length != 0) {
                        <p style="text-transform: capitalize">{{acc?.repDescription}}
                        </p>
                      }
                      @if (acc?.repFax?.length != 0) {
                        <div class="email">
                          <span>Fax: {{acc?.repFax}}</span>
                        </div>
                      }
                      @if (acc?.repEmail?.length != 0) {
                        <div class="email">
                          <a href="{{'mailto:'+acc?.repEmail}}"><img src="/icons/mail.svg"
                          alt="Mail">{{acc?.repEmail}}</a>
                        </div>
                      }
                      @if (acc?.repPhone.length != 0) {
                        <div class="phone">
                          <span>
                            <a href="javascript:void(0)">
                              <img src="/icons/phone.svg" alt="Phone">
                              {{formatPhoneNumber(acc?.repPhone)}}
                            </a></span>
                          </div>
                        }
                      </div>
                      <hr>
                      </section>
                    }
                  </div>
                }
                <div class="d-flex need-assistance">
                  <div class="content">
                    @if (customerRepDetails != undefined && customerRepDetails.length > 0 && baseSiteId == 'vsh') {
                      <h4>Need
                      assistance?</h4>
                    }
                    @if (!customerRepDetails || customerRepDetails.length == 0) {
                      <div>
                        <app-need-assistance></app-need-assistance>
                      </div>
                    }
                    @if (baseSiteId == 'vsh') {
                      <div class="request-support">
                        <a id="customerReqSupportFooter" (click)="openModal()">
                          <img [src]="'/icons/'+baseSiteId+'/request-support.png'" alt="">
                        Request support</a>
                      </div>
                    }
                  </div>
                </div>
              </li>
            </ul>
          </section>
        </section>
